<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}考试`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="activeTab" class="fx-g1 fx-col inner_tags-page">
                 <el-tab-pane label="考试" name="saveExam">
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="封面">
                            <el-upload
                                class="photo_uploader"
                                action=""
                                :show-file-list="false"
                                :before-upload="uploadBackgroundImg">
                                <img v-if="form.imgPath != null" :src="form.imgPath" class="avatar">
                                <i v-else class="el-icon-plus uploader-icon"></i>
                            </el-upload>
                            <el-button type="primary" size="small" @click="showBanner()">从总部图库添加</el-button>
                        </el-form-item>
                        <el-form-item label="考试名称" v-check="{'必填': !form.name}">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="考试时长"
                            prop="keepTime"
                            v-check="{'必填': !form.keepTime}"
                        >
                            <el-input-number type="keepTime" v-model="form.keepTime"  :min="1"  label="" ></el-input-number>
<!--                            <el-input type="keepTime" v-model.number="form.keepTime" autocomplete="off"></el-input>-->
                        </el-form-item>
                        <el-form-item
                            label="总分"
                            prop="score"
                            v-check="{'必填': !form.score}"
                        >
                            <el-input-number type="score" v-model="form.score"  :min="1"  label="" ></el-input-number>
<!--                            <el-input type="score" v-model.number="form.score" autocomplete="off"></el-input>-->
                        </el-form-item>
                        <el-form-item label="考试时间" v-check="{'必填': !form.datesVelue}">
                            <el-date-picker
                                v-model="form.datesVelue"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="批阅时间" v-check="{'必填': !form.datesMarkerVelue}">
                            <el-date-picker
                                v-model="form.datesMarkerVelue"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="总部图库" name="addBanner" v-if="bannerShow">
                    <el-table
                        ref="bannerTable"
                        :data="bannerLib"
                        style="width: 100%;overflow: auto;"
                    >
                        <el-table-column
                            type="radio"
                            width="55">
                             <template slot-scope="scope">
                                <el-radio v-model="radio" :label="scope.row.id" @change="handlePicChoose(scope.row)">{{''}}</el-radio>
                             </template>
                        </el-table-column>
                        <el-table-column
                            min-width="460px"
                            label="" >
                            <template slot-scope="scope">
                                <img :src="scope.row.value" style="width: 500px; height: 220px">
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>
        </div>
        <span class="fx fx-center">
            <el-button  type="primary" @click="subOne()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                needRefreshParent: false,
                form: {
                    ...this.item,
                    // datesVelue:[],
                    // datesMarkerVelue:[],
                },
                showLoading: false,
                activeTab: 'saveExam',
                bannerLib:[],
                radio: '',
                bannerShow: false,
            }

        },
        computed: {
        },
        watch: {
        },
        methods: {
            subOne() {
                if(this.activeTab == 'addBanner'){
                    this.activeTab = 'saveExam';
                    this.bannerShow = false;
                }else{
                    this.$checkForm(this.$refs.form).then(success => {
                        if (success) {
                            //校验通过，干什么....
                            this.form.startTime = this.form.datesVelue != null ? this.form.datesVelue[0] : "";
                            this.form.endTime =  this.form.datesVelue != null ? this.form.datesVelue[1] : "";
                            this.form.startDateMarker = this.form.datesMarkerVelue != null ?  this.form.datesMarkerVelue[0] : "";
                            this.form.endDateMarker =  this.form.datesMarkerVelue != null ? this.form.datesMarkerVelue[1] : "";
                            this.$ajaxPost("/exam/save", {
                                exam: this.form
                            }, (data) => {
                                this.$emit("submit", data.result);
                                this.showLoading = false;
                                this.needRefreshParent = true;
                                this.$showSuccess("保存成功");
                            })
                            return false;
                        } else {
                            this.$showError("请输入内容再保存");
                        }
                    })
                }
            },
            showBanner() {
                this.bannerShow = true;
                this.activeTab = 'addBanner';
            },
            handlePicChoose(item) {
                this.form.imgPath = item.value;
            },
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            selectable(row, index) {
                return row.canChoose;
            },
            uploadBackgroundImg(file) {
                this.$uploadQiniu(file, "exam/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {imgPath: file.url});
                        }
                    }
                )
                return false;
            },
            loadBannerData() {
                //加载总部图库
                this.$ajaxGet("/dictionary/listCenterBannerLib/3", data => {
                    this.bannerLib = data.result;
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            if(this.item.id > 0){
                this.form.datesVelue[0] = this.form.startTime;
                this.form.datesVelue[1] = this.form.endTime;
                this.form.datesMarkerVelue[0] = this.form.startDateMarker;
                this.form.datesMarkerVelue[1] = this.form.endDateMarker;
            }
            this.loadBannerData();
        }
    }
</script>
